import { useState } from "react";
import { Link } from "react-router-dom";
import FactoryProductUploadModal from "./FactoryProductUploadModal";
import FactoryMessagingModal from "./FactoryMessagingModal";
import SampleOrderModal from "@/pages/wholesale/components/SampleOrderModal";
import BulkOrderModal from "@/pages/wholesale/components/BulkOrderModal";

const featuredFactories = [
  {
    id: "wf1",
    flag: "🇨🇳",
    country: "China",
    city: "Shenzhen",
    name: "SinoTech Electronics Co.",
    category: "Consumer Electronics",
    rating: 4.8,
    orders: "1,240+",
    moq: "$8,000",
    certifications: ["ISO 9001", "CE", "FCC"],
    topProduct: "TWS Wireless Earbuds OEM",
    unitPrice: "$8.50",
    containers: "20ft / 40ft / 40ft HC",
    samplePrice: "$150",
    leadTime: "25-35 days",
    verified: true,
    responseTime: "< 4 hours",
    image: "https://public.readdy.ai/ai/img_res/d0676c43f799fcb96693b00bbd530358.jpg",
    avatar: "https://readdy.ai/api/search-image?query=chinese%20electronics%20manufacturing%20company%20logo%20professional%20clean%20minimal%20circle%20icon&width=60&height=60&seq=gfmav1&orientation=squarish",
    mockProduct: { id: "wp1", title: "TWS Wireless Earbuds OEM", unitPrice: 8.50, moqUnits: 1000, moqUSD: 8500, containerQty: { "20ft": 18000, "40ft": 38000 }, image: "https://readdy.ai/api/search-image?query=wireless%20earbuds%20bulk%20wholesale%20packaging%20factory%20oem%20white%20background%20product%20photography&width=400&height=400&seq=gfm1p&orientation=squarish", category: "Electronics", customizable: true },
    mockFactory: { name: "SinoTech Electronics Co.", flag: "🇨🇳", minOrderUSD: 8000, containerTypes: ["20ft", "40ft", "40ft HC"], bulkLeadTime: "25-35 days", samplePrice: 150, sampleLeadTime: "5-7 days" },
  },
  {
    id: "wf5",
    flag: "🇰🇷",
    country: "South Korea",
    city: "Seoul",
    name: "KoreaBeauty Factory Co.",
    category: "K-Beauty & Skincare",
    rating: 4.9,
    orders: "2,100+",
    moq: "$8,000",
    certifications: ["KFDA", "GMP", "Cruelty-Free"],
    topProduct: "Hyaluronic Acid Serum OEM",
    unitPrice: "$3.20",
    containers: "20ft / 40ft",
    samplePrice: "$95",
    leadTime: "20-28 days",
    verified: true,
    responseTime: "< 2 hours",
    image: "https://readdy.ai/api/search-image?query=hyaluronic%20acid%20serum%20bottle%20bulk%20wholesale%20korean%20beauty%20oem%20white%20background%20product%20photography&width=400&height=300&seq=gfm2&orientation=landscape",
    avatar: "https://readdy.ai/api/search-image?query=korean%20beauty%20cosmetics%20company%20logo%20professional%20clean%20minimal%20circle%20icon%20pink&width=60&height=60&seq=gfmav2&orientation=squarish",
    mockProduct: { id: "wp8", title: "Hyaluronic Acid Serum OEM", unitPrice: 3.20, moqUnits: 2500, moqUSD: 8000, containerQty: { "20ft": 55000, "40ft": 115000 }, image: "https://readdy.ai/api/search-image?query=hyaluronic%20acid%20serum%20bottle%20bulk%20wholesale%20korean%20beauty%20oem%20white%20background%20product%20photography&width=400&height=400&seq=gfm2p&orientation=squarish", category: "Beauty", customizable: true },
    mockFactory: { name: "KoreaBeauty Factory Co.", flag: "🇰🇷", minOrderUSD: 8000, containerTypes: ["20ft", "40ft"], bulkLeadTime: "20-28 days", samplePrice: 95, sampleLeadTime: "3-5 days" },
  },
  {
    id: "wf2",
    flag: "🇺🇸",
    country: "USA",
    city: "Los Angeles, CA",
    name: "GreenThread Textile Mills",
    category: "Fashion & Apparel",
    rating: 4.9,
    orders: "890+",
    moq: "$8,000",
    certifications: ["GOTS", "OEKO-TEX", "Fair Trade"],
    topProduct: "Organic Cotton Hoodies Private Label",
    unitPrice: "$12.50",
    containers: "20ft / 40ft",
    samplePrice: "$80",
    leadTime: "15-25 days",
    verified: true,
    responseTime: "< 2 hours",
    image: "https://readdy.ai/api/search-image?query=organic%20cotton%20hoodies%20bulk%20wholesale%20stack%20folded%20clean%20white%20background%20product%20photography&width=400&height=300&seq=gfm3&orientation=landscape",
    avatar: "https://readdy.ai/api/search-image?query=american%20textile%20company%20logo%20green%20leaf%20professional%20clean%20minimal%20circle%20icon&width=60&height=60&seq=gfmav3&orientation=squarish",
    mockProduct: { id: "wp3", title: "Organic Cotton Hoodies Private Label", unitPrice: 12.50, moqUnits: 640, moqUSD: 8000, containerQty: { "20ft": 8000, "40ft": 16500 }, image: "https://readdy.ai/api/search-image?query=organic%20cotton%20hoodies%20bulk%20wholesale%20stack%20folded%20clean%20white%20background%20product%20photography&width=400&height=400&seq=gfm3p&orientation=squarish", category: "Fashion", customizable: true },
    mockFactory: { name: "GreenThread Textile Mills", flag: "🇺🇸", minOrderUSD: 8000, containerTypes: ["20ft", "40ft"], bulkLeadTime: "15-25 days", samplePrice: 80, sampleLeadTime: "3-5 days" },
  },
  {
    id: "wf7",
    flag: "🇮🇹",
    country: "Italy",
    city: "Florence",
    name: "ItaliaLeather S.r.l.",
    category: "Luxury Leather Goods",
    rating: 4.9,
    orders: "340+",
    moq: "$12,000",
    certifications: ["ICEC", "ISO 9001", "Made in Italy"],
    topProduct: "Genuine Italian Leather Handbags",
    unitPrice: "$85.00",
    containers: "20ft / 40ft",
    samplePrice: "$450",
    leadTime: "45-60 days",
    verified: true,
    responseTime: "< 8 hours",
    image: "https://readdy.ai/api/search-image?query=genuine%20italian%20leather%20handbag%20luxury%20bulk%20wholesale%20white%20background%20product%20photography%20clean%20minimal&width=400&height=300&seq=gfm4&orientation=landscape",
    avatar: "https://readdy.ai/api/search-image?query=italian%20leather%20goods%20company%20logo%20professional%20clean%20minimal%20circle%20icon%20luxury&width=60&height=60&seq=gfmav4&orientation=squarish",
    mockProduct: { id: "wp11", title: "Genuine Italian Leather Handbags", unitPrice: 85.00, moqUnits: 142, moqUSD: 12070, containerQty: { "20ft": 2800, "40ft": 6000 }, image: "https://readdy.ai/api/search-image?query=genuine%20italian%20leather%20handbag%20luxury%20bulk%20wholesale%20white%20background%20product%20photography%20clean%20minimal&width=400&height=400&seq=gfm4p&orientation=squarish", category: "Fashion", customizable: true },
    mockFactory: { name: "ItaliaLeather S.r.l.", flag: "🇮🇹", minOrderUSD: 12000, containerTypes: ["20ft", "40ft"], bulkLeadTime: "45-60 days", samplePrice: 450, sampleLeadTime: "10-14 days" },
  },
  {
    id: "wf3",
    flag: "🇩🇪",
    country: "Germany",
    city: "Stuttgart",
    name: "EuroHome Furniture GmbH",
    category: "Home & Furniture",
    rating: 4.7,
    orders: "560+",
    moq: "$10,000",
    certifications: ["FSC", "ISO 14001", "CE"],
    topProduct: "Solid Oak Dining Table Set",
    unitPrice: "$280.00",
    containers: "20ft / 40ft / 40ft HC",
    samplePrice: "$300",
    leadTime: "30-45 days",
    verified: true,
    responseTime: "< 6 hours",
    image: "https://readdy.ai/api/search-image?query=solid%20oak%20dining%20table%20set%20modern%20minimalist%20furniture%20white%20background%20product%20photography%20clean&width=400&height=300&seq=gfm5&orientation=landscape",
    avatar: "https://readdy.ai/api/search-image?query=german%20furniture%20company%20logo%20professional%20clean%20minimal%20circle%20icon%20modern&width=60&height=60&seq=gfmav5&orientation=squarish",
    mockProduct: { id: "wp5", title: "Solid Oak Dining Table Set", unitPrice: 280.00, moqUnits: 36, moqUSD: 10080, containerQty: { "20ft": 36, "40ft": 80 }, image: "https://readdy.ai/api/search-image?query=solid%20oak%20dining%20table%20set%20modern%20minimalist%20furniture%20white%20background%20product%20photography%20clean&width=400&height=400&seq=gfm5p&orientation=squarish", category: "Furniture", customizable: false },
    mockFactory: { name: "EuroHome Furniture GmbH", flag: "🇩🇪", minOrderUSD: 10000, containerTypes: ["20ft", "40ft", "40ft HC"], bulkLeadTime: "30-45 days", samplePrice: 300, sampleLeadTime: "7-10 days" },
  },
  {
    id: "wf10",
    flag: "🇯🇵",
    country: "Japan",
    city: "Osaka",
    name: "JapanPrecision Mfg. K.K.",
    category: "Precision Tools & Hardware",
    rating: 5.0,
    orders: "480+",
    moq: "$10,000",
    certifications: ["JIS", "ISO 9001", "CE"],
    topProduct: "Professional Tool Set 120pc",
    unitPrice: "$42.00",
    containers: "20ft / 40ft",
    samplePrice: "$280",
    leadTime: "30-40 days",
    verified: true,
    responseTime: "< 6 hours",
    image: "https://readdy.ai/api/search-image?query=professional%20tool%20set%20120%20piece%20bulk%20wholesale%20white%20background%20product%20photography%20clean%20minimal&width=400&height=300&seq=gfm6&orientation=landscape",
    avatar: "https://readdy.ai/api/search-image?query=japanese%20precision%20manufacturing%20company%20logo%20professional%20clean%20minimal%20circle%20icon%20technology&width=60&height=60&seq=gfmav6&orientation=squarish",
    mockProduct: { id: "wp15", title: "Professional Tool Set 120pc", unitPrice: 42.00, moqUnits: 240, moqUSD: 10080, containerQty: { "20ft": 3200, "40ft": 6800 }, image: "https://readdy.ai/api/search-image?query=professional%20tool%20set%20120%20piece%20bulk%20wholesale%20white%20background%20product%20photography%20clean%20minimal&width=400&height=400&seq=gfm6p&orientation=squarish", category: "Hardware", customizable: false },
    mockFactory: { name: "JapanPrecision Mfg. K.K.", flag: "🇯🇵", minOrderUSD: 10000, containerTypes: ["20ft", "40ft"], bulkLeadTime: "30-40 days", samplePrice: 280, sampleLeadTime: "7-12 days" },
  },
  // ── Beautiful Clothes Factories ──
  {
    id: "wf11",
    flag: "🇫🇷",
    country: "France",
    city: "Paris",
    name: "Maison Élégance Couture",
    category: "Luxury Women's Fashion",
    rating: 4.9,
    orders: "620+",
    moq: "$9,000",
    certifications: ["OEKO-TEX", "ISO 9001", "Made in France"],
    topProduct: "Designer Floral Silk Dresses OEM",
    unitPrice: "$38.00",
    containers: "20ft / 40ft",
    samplePrice: "$120",
    leadTime: "20-30 days",
    verified: true,
    responseTime: "< 3 hours",
    image: "https://readdy.ai/api/search-image?query=beautiful%20elegant%20designer%20floral%20silk%20dresses%20collection%20luxury%20fashion%20women%20colorful%20hanging%20showroom%20clean%20white%20background%20photography&width=400&height=300&seq=gfm-clothes1&orientation=landscape",
    avatar: "https://readdy.ai/api/search-image?query=french%20fashion%20couture%20company%20logo%20elegant%20minimal%20circle%20icon%20luxury&width=60&height=60&seq=gfmav-c1&orientation=squarish",
    mockProduct: { id: "wp-c1", title: "Designer Floral Silk Dresses OEM", unitPrice: 38.00, moqUnits: 237, moqUSD: 9006, containerQty: { "20ft": 4200, "40ft": 8800 }, image: "https://readdy.ai/api/search-image?query=beautiful%20elegant%20designer%20floral%20silk%20dresses%20collection%20luxury%20fashion%20women%20colorful%20hanging%20showroom%20clean%20white%20background%20photography&width=400&height=400&seq=gfm-clothes1p&orientation=squarish", category: "Fashion", customizable: true },
    mockFactory: { name: "Maison Élégance Couture", flag: "🇫🇷", minOrderUSD: 9000, containerTypes: ["20ft", "40ft"], bulkLeadTime: "20-30 days", samplePrice: 120, sampleLeadTime: "5-7 days" },
  },
  {
    id: "wf12",
    flag: "🇹🇷",
    country: "Turkey",
    city: "Istanbul",
    name: "TurkStyle Apparel Factory",
    category: "Summer & Resort Wear",
    rating: 4.8,
    orders: "1,050+",
    moq: "$8,000",
    certifications: ["GOTS", "OEKO-TEX", "ISO 9001"],
    topProduct: "Women's Summer Maxi Dress Collection",
    unitPrice: "$14.50",
    containers: "20ft / 40ft / 40ft HC",
    samplePrice: "$75",
    leadTime: "18-25 days",
    verified: true,
    responseTime: "< 2 hours",
    image: "https://readdy.ai/api/search-image?query=beautiful%20colorful%20women%20summer%20maxi%20dresses%20resort%20wear%20boho%20style%20bulk%20wholesale%20rack%20display%20clean%20white%20background%20product%20photography&width=400&height=300&seq=gfm-clothes2&orientation=landscape",
    avatar: "https://readdy.ai/api/search-image?query=turkish%20apparel%20fashion%20company%20logo%20professional%20clean%20minimal%20circle%20icon%20colorful&width=60&height=60&seq=gfmav-c2&orientation=squarish",
    mockProduct: { id: "wp-c2", title: "Women's Summer Maxi Dress Collection", unitPrice: 14.50, moqUnits: 552, moqUSD: 8004, containerQty: { "20ft": 12000, "40ft": 25000 }, image: "https://readdy.ai/api/search-image?query=beautiful%20colorful%20women%20summer%20maxi%20dresses%20resort%20wear%20boho%20style%20bulk%20wholesale%20rack%20display%20clean%20white%20background%20product%20photography&width=400&height=400&seq=gfm-clothes2p&orientation=squarish", category: "Fashion", customizable: true },
    mockFactory: { name: "TurkStyle Apparel Factory", flag: "🇹🇷", minOrderUSD: 8000, containerTypes: ["20ft", "40ft", "40ft HC"], bulkLeadTime: "18-25 days", samplePrice: 75, sampleLeadTime: "4-6 days" },
  },
  {
    id: "wf13",
    flag: "🇮🇳",
    country: "India",
    city: "Jaipur",
    name: "IndiaLoom Textile Co.",
    category: "Ethnic & Boho Fashion",
    rating: 4.8,
    orders: "780+",
    moq: "$8,000",
    certifications: ["GOTS", "Fair Trade", "OEKO-TEX"],
    topProduct: "Hand-Embroidered Boho Blouses & Kaftans",
    unitPrice: "$9.80",
    containers: "20ft / 40ft",
    samplePrice: "$60",
    leadTime: "22-32 days",
    verified: true,
    responseTime: "< 4 hours",
    image: "https://readdy.ai/api/search-image?query=beautiful%20hand%20embroidered%20boho%20blouses%20kaftans%20ethnic%20fashion%20colorful%20India%20textile%20bulk%20wholesale%20display%20clean%20white%20background%20product%20photography&width=400&height=300&seq=gfm-clothes3&orientation=landscape",
    avatar: "https://readdy.ai/api/search-image?query=indian%20textile%20fashion%20company%20logo%20professional%20clean%20minimal%20circle%20icon%20colorful%20ethnic&width=60&height=60&seq=gfmav-c3&orientation=squarish",
    mockProduct: { id: "wp-c3", title: "Hand-Embroidered Boho Blouses & Kaftans", unitPrice: 9.80, moqUnits: 817, moqUSD: 8007, containerQty: { "20ft": 18000, "40ft": 38000 }, image: "https://readdy.ai/api/search-image?query=beautiful%20hand%20embroidered%20boho%20blouses%20kaftans%20ethnic%20fashion%20colorful%20India%20textile%20bulk%20wholesale%20display%20clean%20white%20background%20product%20photography&width=400&height=400&seq=gfm-clothes3p&orientation=squarish", category: "Fashion", customizable: true },
    mockFactory: { name: "IndiaLoom Textile Co.", flag: "🇮🇳", minOrderUSD: 8000, containerTypes: ["20ft", "40ft"], bulkLeadTime: "22-32 days", samplePrice: 60, sampleLeadTime: "5-8 days" },
  },
  // ── Wine Factories ──
  {
    id: "wf16",
    flag: "🇫🇷",
    country: "France",
    city: "Bordeaux",
    name: "Château Bordeaux Négociant",
    category: "Fine Wine & Spirits",
    rating: 4.9,
    orders: "540+",
    moq: "$10,000",
    certifications: ["AOC", "ISO 22000", "HACCP"],
    topProduct: "Bordeaux Red Wine Private Label OEM",
    unitPrice: "$6.80",
    containers: "20ft / 40ft",
    samplePrice: "$180",
    leadTime: "20-30 days",
    verified: true,
    responseTime: "< 4 hours",
    image: "https://readdy.ai/api/search-image?query=elegant%20bordeaux%20red%20wine%20bottles%20collection%20wooden%20cellar%20barrels%20golden%20light%20luxury%20French%20winery%20beautiful%20product%20photography&width=400&height=300&seq=gfm-wine1&orientation=landscape",
    avatar: "https://readdy.ai/api/search-image?query=french%20wine%20chateau%20company%20logo%20elegant%20minimal%20circle%20icon%20gold%20grape%20vine&width=60&height=60&seq=gfmav-w1&orientation=squarish",
    mockProduct: { id: "wp-wine1", title: "Bordeaux Red Wine Private Label OEM", unitPrice: 6.80, moqUnits: 1470, moqUSD: 9996, containerQty: { "20ft": 14400, "40ft": 30000 }, image: "https://readdy.ai/api/search-image?query=elegant%20bordeaux%20red%20wine%20bottles%20collection%20wooden%20cellar%20barrels%20golden%20light%20luxury%20French%20winery%20beautiful%20product%20photography&width=400&height=400&seq=gfm-wine1p&orientation=squarish", category: "Wine", customizable: true },
    mockFactory: { name: "Château Bordeaux Négociant", flag: "🇫🇷", minOrderUSD: 10000, containerTypes: ["20ft", "40ft"], bulkLeadTime: "20-30 days", samplePrice: 180, sampleLeadTime: "5-7 days" },
  },
  {
    id: "wf17",
    flag: "🇮🇹",
    country: "Italy",
    city: "Tuscany",
    name: "Toscana Vino Export S.r.l.",
    category: "Italian Wine & Prosecco",
    rating: 4.8,
    orders: "390+",
    moq: "$9,000",
    certifications: ["DOC", "DOCG", "ISO 22000"],
    topProduct: "Chianti & Prosecco Mixed Case OEM",
    unitPrice: "$5.40",
    containers: "20ft / 40ft",
    samplePrice: "$150",
    leadTime: "18-28 days",
    verified: true,
    responseTime: "< 5 hours",
    image: "https://readdy.ai/api/search-image?query=beautiful%20Italian%20Chianti%20Prosecco%20wine%20bottles%20vineyard%20Tuscany%20rolling%20hills%20golden%20sunset%20rustic%20wooden%20table%20elegant%20product%20photography&width=400&height=300&seq=gfm-wine2&orientation=landscape",
    avatar: "https://readdy.ai/api/search-image?query=italian%20wine%20export%20company%20logo%20elegant%20minimal%20circle%20icon%20red%20grape%20Tuscany&width=60&height=60&seq=gfmav-w2&orientation=squarish",
    mockProduct: { id: "wp-wine2", title: "Chianti & Prosecco Mixed Case OEM", unitPrice: 5.40, moqUnits: 1667, moqUSD: 9002, containerQty: { "20ft": 18000, "40ft": 38000 }, image: "https://readdy.ai/api/search-image?query=beautiful%20Italian%20Chianti%20Prosecco%20wine%20bottles%20vineyard%20Tuscany%20rolling%20hills%20golden%20sunset%20rustic%20wooden%20table%20elegant%20product%20photography&width=400&height=400&seq=gfm-wine2p&orientation=squarish", category: "Wine", customizable: true },
    mockFactory: { name: "Toscana Vino Export S.r.l.", flag: "🇮🇹", minOrderUSD: 9000, containerTypes: ["20ft", "40ft"], bulkLeadTime: "18-28 days", samplePrice: 150, sampleLeadTime: "5-8 days" },
  },
  {
    id: "wf18",
    flag: "🇦🇺",
    country: "Australia",
    city: "Barossa Valley",
    name: "BarossaVine Exports Pty",
    category: "Australian Premium Wine",
    rating: 4.7,
    orders: "280+",
    moq: "$8,000",
    certifications: ["AWBC", "ISO 22000", "Organic"],
    topProduct: "Shiraz & Chardonnay Private Label",
    unitPrice: "$7.20",
    containers: "20ft / 40ft",
    samplePrice: "$160",
    leadTime: "22-32 days",
    verified: true,
    responseTime: "< 6 hours",
    image: "https://readdy.ai/api/search-image?query=premium%20Australian%20Shiraz%20Chardonnay%20wine%20bottles%20Barossa%20Valley%20vineyard%20lush%20green%20landscape%20beautiful%20clean%20product%20photography%20white%20background&width=400&height=300&seq=gfm-wine3&orientation=landscape",
    avatar: "https://readdy.ai/api/search-image?query=australian%20wine%20export%20company%20logo%20minimal%20circle%20icon%20green%20kangaroo%20grape%20vine&width=60&height=60&seq=gfmav-w3&orientation=squarish",
    mockProduct: { id: "wp-wine3", title: "Shiraz & Chardonnay Private Label", unitPrice: 7.20, moqUnits: 1112, moqUSD: 8006, containerQty: { "20ft": 12000, "40ft": 25000 }, image: "https://readdy.ai/api/search-image?query=premium%20Australian%20Shiraz%20Chardonnay%20wine%20bottles%20Barossa%20Valley%20vineyard%20lush%20green%20landscape%20beautiful%20clean%20product%20photography%20white%20background&width=400&height=400&seq=gfm-wine3p&orientation=squarish", category: "Wine", customizable: true },
    mockFactory: { name: "BarossaVine Exports Pty", flag: "🇦🇺", minOrderUSD: 8000, containerTypes: ["20ft", "40ft"], bulkLeadTime: "22-32 days", samplePrice: 160, sampleLeadTime: "7-10 days" },
  },
  // ── Makeup & Cosmetics Factories ──
  {
    id: "wf19",
    flag: "🇺🇸",
    country: "USA",
    city: "New York, NY",
    name: "GlamLab Cosmetics USA",
    category: "Makeup & Color Cosmetics",
    rating: 4.9,
    orders: "1,320+",
    moq: "$8,000",
    certifications: ["FDA", "GMP", "Cruelty-Free"],
    topProduct: "Full-Coverage Matte Foundation OEM",
    unitPrice: "$4.20",
    containers: "20ft / 40ft",
    samplePrice: "$90",
    leadTime: "15-22 days",
    verified: true,
    responseTime: "< 2 hours",
    image: "https://readdy.ai/api/search-image?query=luxury%20makeup%20collection%20foundation%20lipstick%20eyeshadow%20palette%20beautiful%20flat%20lay%20white%20marble%20background%20glamorous%20product%20photography%20USA%20cosmetics&width=400&height=300&seq=gfm-makeup1&orientation=landscape",
    avatar: "https://readdy.ai/api/search-image?query=USA%20cosmetics%20makeup%20brand%20company%20logo%20elegant%20minimal%20circle%20icon%20pink%20gold&width=60&height=60&seq=gfmav-m1&orientation=squarish",
    mockProduct: { id: "wp-makeup1", title: "Full-Coverage Matte Foundation OEM", unitPrice: 4.20, moqUnits: 1905, moqUSD: 8001, containerQty: { "20ft": 42000, "40ft": 88000 }, image: "https://readdy.ai/api/search-image?query=luxury%20makeup%20collection%20foundation%20lipstick%20eyeshadow%20palette%20beautiful%20flat%20lay%20white%20marble%20background%20glamorous%20product%20photography%20USA%20cosmetics&width=400&height=400&seq=gfm-makeup1p&orientation=squarish", category: "Beauty", customizable: true },
    mockFactory: { name: "GlamLab Cosmetics USA", flag: "🇺🇸", minOrderUSD: 8000, containerTypes: ["20ft", "40ft"], bulkLeadTime: "15-22 days", samplePrice: 90, sampleLeadTime: "3-5 days" },
  },
  {
    id: "wf20",
    flag: "🇫🇷",
    country: "France",
    city: "Paris",
    name: "Lumière Beauté Paris",
    category: "Luxury Makeup & Skincare",
    rating: 5.0,
    orders: "760+",
    moq: "$10,000",
    certifications: ["ECOCERT", "ISO 22716", "Vegan"],
    topProduct: "Luxury Velvet Lipstick Collection OEM",
    unitPrice: "$8.50",
    containers: "20ft / 40ft",
    samplePrice: "$200",
    leadTime: "25-35 days",
    verified: true,
    responseTime: "< 3 hours",
    image: "https://readdy.ai/api/search-image?query=luxury%20French%20Paris%20makeup%20lipstick%20collection%20velvet%20gold%20packaging%20beautiful%20elegant%20flat%20lay%20rose%20petals%20white%20background%20product%20photography&width=400&height=300&seq=gfm-makeup2&orientation=landscape",
    avatar: "https://readdy.ai/api/search-image?query=french%20luxury%20beauty%20cosmetics%20company%20logo%20elegant%20minimal%20circle%20icon%20gold%20Paris&width=60&height=60&seq=gfmav-m2&orientation=squarish",
    mockProduct: { id: "wp-makeup2", title: "Luxury Velvet Lipstick Collection OEM", unitPrice: 8.50, moqUnits: 1177, moqUSD: 10005, containerQty: { "20ft": 28000, "40ft": 58000 }, image: "https://readdy.ai/api/search-image?query=luxury%20French%20Paris%20makeup%20lipstick%20collection%20velvet%20gold%20packaging%20beautiful%20elegant%20flat%20lay%20rose%20petals%20white%20background%20product%20photography&width=400&height=400&seq=gfm-makeup2p&orientation=squarish", category: "Beauty", customizable: true },
    mockFactory: { name: "Lumière Beauté Paris", flag: "🇫🇷", minOrderUSD: 10000, containerTypes: ["20ft", "40ft"], bulkLeadTime: "25-35 days", samplePrice: 200, sampleLeadTime: "5-7 days" },
  },
  {
    id: "wf21",
    flag: "🇰🇷",
    country: "South Korea",
    city: "Seoul",
    name: "K-Glow Cosmetics Factory",
    category: "K-Beauty Makeup & BB Cream",
    rating: 4.9,
    orders: "2,450+",
    moq: "$8,000",
    certifications: ["KFDA", "GMP", "ISO 22716"],
    topProduct: "K-Beauty BB Cream & Cushion OEM",
    unitPrice: "$2.80",
    containers: "20ft / 40ft / 40ft HC",
    samplePrice: "$85",
    leadTime: "18-25 days",
    verified: true,
    responseTime: "< 2 hours",
    image: "https://readdy.ai/api/search-image?query=Korean%20beauty%20K-beauty%20makeup%20BB%20cream%20cushion%20compact%20collection%20pastel%20pink%20white%20background%20beautiful%20clean%20product%20photography%20Seoul%20cosmetics&width=400&height=300&seq=gfm-makeup3&orientation=landscape",
    avatar: "https://readdy.ai/api/search-image?query=korean%20beauty%20cosmetics%20makeup%20company%20logo%20minimal%20circle%20icon%20pastel%20pink%20Seoul&width=60&height=60&seq=gfmav-m3&orientation=squarish",
    mockProduct: { id: "wp-makeup3", title: "K-Beauty BB Cream & Cushion OEM", unitPrice: 2.80, moqUnits: 2858, moqUSD: 8002, containerQty: { "20ft": 65000, "40ft": 135000 }, image: "https://readdy.ai/api/search-image?query=Korean%20beauty%20K-beauty%20makeup%20BB%20cream%20cushion%20compact%20collection%20pastel%20pink%20white%20background%20beautiful%20clean%20product%20photography%20Seoul%20cosmetics&width=400&height=400&seq=gfm-makeup3p&orientation=squarish", category: "Beauty", customizable: true },
    mockFactory: { name: "K-Glow Cosmetics Factory", flag: "🇰🇷", minOrderUSD: 8000, containerTypes: ["20ft", "40ft", "40ft HC"], bulkLeadTime: "18-25 days", samplePrice: 85, sampleLeadTime: "3-5 days" },
  },
  {
    id: "wf22",
    flag: "🇨🇳",
    country: "China",
    city: "Guangzhou",
    name: "SinoGlam Beauty OEM Co.",
    category: "Eyeshadow & Makeup Tools",
    rating: 4.7,
    orders: "3,100+",
    moq: "$8,000",
    certifications: ["ISO 22716", "GMP", "SGS"],
    topProduct: "80-Color Eyeshadow Palette Private Label",
    unitPrice: "$3.50",
    containers: "20ft / 40ft / 40ft HC",
    samplePrice: "$70",
    leadTime: "15-20 days",
    verified: true,
    responseTime: "< 2 hours",
    image: "https://readdy.ai/api/search-image?query=colorful%2080%20color%20eyeshadow%20palette%20makeup%20collection%20vibrant%20pigments%20beautiful%20flat%20lay%20white%20background%20professional%20product%20photography%20cosmetics&width=400&height=300&seq=gfm-makeup4&orientation=landscape",
    avatar: "https://readdy.ai/api/search-image?query=chinese%20beauty%20cosmetics%20OEM%20company%20logo%20minimal%20circle%20icon%20colorful%20makeup&width=60&height=60&seq=gfmav-m4&orientation=squarish",
    mockProduct: { id: "wp-makeup4", title: "80-Color Eyeshadow Palette Private Label", unitPrice: 3.50, moqUnits: 2286, moqUSD: 8001, containerQty: { "20ft": 52000, "40ft": 108000 }, image: "https://readdy.ai/api/search-image?query=colorful%2080%20color%20eyeshadow%20palette%20makeup%20collection%20vibrant%20pigments%20beautiful%20flat%20lay%20white%20background%20professional%20product%20photography%20cosmetics&width=400&height=400&seq=gfm-makeup4p&orientation=squarish", category: "Beauty", customizable: true },
    mockFactory: { name: "SinoGlam Beauty OEM Co.", flag: "🇨🇳", minOrderUSD: 8000, containerTypes: ["20ft", "40ft", "40ft HC"], bulkLeadTime: "15-20 days", samplePrice: 70, sampleLeadTime: "3-5 days" },
  },
  // ── Handbag Factories ──
  {
    id: "wf23",
    flag: "🇮🇹",
    country: "Italy",
    city: "Milan",
    name: "Milano Borsa Artigianale",
    category: "Luxury Designer Handbags",
    rating: 5.0,
    orders: "420+",
    moq: "$12,000",
    certifications: ["ICEC", "ISO 9001", "Made in Italy"],
    topProduct: "Structured Leather Tote Bag OEM",
    unitPrice: "$95.00",
    containers: "20ft / 40ft",
    samplePrice: "$480",
    leadTime: "40-55 days",
    verified: true,
    responseTime: "< 6 hours",
    image: "https://readdy.ai/api/search-image?query=luxury%20Italian%20leather%20designer%20handbag%20tote%20structured%20elegant%20Milan%20fashion%20week%20white%20background%20beautiful%20product%20photography%20gold%20hardware&width=400&height=300&seq=gfm-bag1&orientation=landscape",
    avatar: "https://readdy.ai/api/search-image?query=Italian%20luxury%20handbag%20fashion%20company%20logo%20elegant%20minimal%20circle%20icon%20gold%20Milan&width=60&height=60&seq=gfmav-b1&orientation=squarish",
    mockProduct: { id: "wp-bag1", title: "Structured Leather Tote Bag OEM", unitPrice: 95.00, moqUnits: 127, moqUSD: 12065, containerQty: { "20ft": 2400, "40ft": 5000 }, image: "https://readdy.ai/api/search-image?query=luxury%20Italian%20leather%20designer%20handbag%20tote%20structured%20elegant%20Milan%20fashion%20week%20white%20background%20beautiful%20product%20photography%20gold%20hardware&width=400&height=400&seq=gfm-bag1p&orientation=squarish", category: "Fashion", customizable: true },
    mockFactory: { name: "Milano Borsa Artigianale", flag: "🇮🇹", minOrderUSD: 12000, containerTypes: ["20ft", "40ft"], bulkLeadTime: "40-55 days", samplePrice: 480, sampleLeadTime: "10-14 days" },
  },
  {
    id: "wf24",
    flag: "🇨🇳",
    country: "China",
    city: "Guangzhou",
    name: "SinoLux Handbag Factory",
    category: "Fashion Handbags & Clutches",
    rating: 4.8,
    orders: "2,800+",
    moq: "$8,000",
    certifications: ["ISO 9001", "SGS", "BSCI"],
    topProduct: "PU Leather Crossbody Bag Collection",
    unitPrice: "$12.50",
    containers: "20ft / 40ft / 40ft HC",
    samplePrice: "$95",
    leadTime: "20-28 days",
    verified: true,
    responseTime: "< 2 hours",
    image: "https://readdy.ai/api/search-image?query=fashionable%20PU%20leather%20crossbody%20handbag%20collection%20multiple%20colors%20women%20accessories%20beautiful%20clean%20white%20background%20product%20photography%20trendy&width=400&height=300&seq=gfm-bag2&orientation=landscape",
    avatar: "https://readdy.ai/api/search-image?query=chinese%20fashion%20handbag%20factory%20company%20logo%20minimal%20circle%20icon%20modern%20stylish&width=60&height=60&seq=gfmav-b2&orientation=squarish",
    mockProduct: { id: "wp-bag2", title: "PU Leather Crossbody Bag Collection", unitPrice: 12.50, moqUnits: 640, moqUSD: 8000, containerQty: { "20ft": 14000, "40ft": 29000 }, image: "https://readdy.ai/api/search-image?query=fashionable%20PU%20leather%20crossbody%20handbag%20collection%20multiple%20colors%20women%20accessories%20beautiful%20clean%20white%20background%20product%20photography%20trendy&width=400&height=400&seq=gfm-bag2p&orientation=squarish", category: "Fashion", customizable: true },
    mockFactory: { name: "SinoLux Handbag Factory", flag: "🇨🇳", minOrderUSD: 8000, containerTypes: ["20ft", "40ft", "40ft HC"], bulkLeadTime: "20-28 days", samplePrice: 95, sampleLeadTime: "4-6 days" },
  },
  {
    id: "wf25",
    flag: "🇹🇷",
    country: "Turkey",
    city: "Istanbul",
    name: "Istanbul Deri Çanta Co.",
    category: "Genuine Leather Handbags",
    rating: 4.8,
    orders: "960+",
    moq: "$9,000",
    certifications: ["ISO 9001", "OEKO-TEX", "BSCI"],
    topProduct: "Genuine Leather Shoulder Bag OEM",
    unitPrice: "$28.00",
    containers: "20ft / 40ft",
    samplePrice: "$140",
    leadTime: "22-30 days",
    verified: true,
    responseTime: "< 3 hours",
    image: "https://readdy.ai/api/search-image?query=genuine%20leather%20shoulder%20handbag%20collection%20Turkish%20craftsmanship%20beautiful%20tan%20brown%20caramel%20colors%20clean%20white%20background%20product%20photography%20elegant&width=400&height=300&seq=gfm-bag3&orientation=landscape",
    avatar: "https://readdy.ai/api/search-image?query=Turkish%20leather%20handbag%20company%20logo%20minimal%20circle%20icon%20brown%20tan%20Istanbul&width=60&height=60&seq=gfmav-b3&orientation=squarish",
    mockProduct: { id: "wp-bag3", title: "Genuine Leather Shoulder Bag OEM", unitPrice: 28.00, moqUnits: 322, moqUSD: 9016, containerQty: { "20ft": 7200, "40ft": 15000 }, image: "https://readdy.ai/api/search-image?query=genuine%20leather%20shoulder%20handbag%20collection%20Turkish%20craftsmanship%20beautiful%20tan%20brown%20caramel%20colors%20clean%20white%20background%20product%20photography%20elegant&width=400&height=400&seq=gfm-bag3p&orientation=squarish", category: "Fashion", customizable: true },
    mockFactory: { name: "Istanbul Deri Çanta Co.", flag: "🇹🇷", minOrderUSD: 9000, containerTypes: ["20ft", "40ft"], bulkLeadTime: "22-30 days", samplePrice: 140, sampleLeadTime: "5-7 days" },
  },
  // ── Golf Cart Factories ──
  {
    id: "wf14",
    flag: "🇺🇸",
    country: "USA",
    city: "Augusta, GA",
    name: "GreenDrive Golf Vehicles",
    category: "Golf Carts & Electric Vehicles",
    rating: 4.9,
    orders: "320+",
    moq: "$15,000",
    certifications: ["UL", "DOT", "ISO 9001"],
    topProduct: "4-Seat Electric Golf Cart — Custom Color",
    unitPrice: "$3,800",
    containers: "20ft / 40ft",
    samplePrice: "$500",
    leadTime: "35-50 days",
    verified: true,
    responseTime: "< 5 hours",
    image: "https://readdy.ai/api/search-image?query=modern%20electric%20golf%20cart%204%20seat%20white%20luxury%20golf%20course%20green%20grass%20sunny%20day%20beautiful%20clean%20product%20photography%20wide%20shot&width=400&height=300&seq=gfm-golf1&orientation=landscape",
    avatar: "https://readdy.ai/api/search-image?query=golf%20cart%20electric%20vehicle%20company%20logo%20professional%20clean%20minimal%20circle%20icon%20green%20USA&width=60&height=60&seq=gfmav-g1&orientation=squarish",
    mockProduct: { id: "wp-g1", title: "4-Seat Electric Golf Cart — Custom Color", unitPrice: 3800, moqUnits: 4, moqUSD: 15200, containerQty: { "20ft": 4, "40ft": 9 }, image: "https://readdy.ai/api/search-image?query=modern%20electric%20golf%20cart%204%20seat%20white%20luxury%20golf%20course%20green%20grass%20sunny%20day%20beautiful%20clean%20product%20photography%20wide%20shot&width=400&height=400&seq=gfm-golf1p&orientation=squarish", category: "Vehicles", customizable: true },
    mockFactory: { name: "GreenDrive Golf Vehicles", flag: "🇺🇸", minOrderUSD: 15000, containerTypes: ["20ft", "40ft"], bulkLeadTime: "35-50 days", samplePrice: 500, sampleLeadTime: "14-21 days" },
  },
  {
    id: "wf15",
    flag: "🇨🇳",
    country: "China",
    city: "Guangzhou",
    name: "SinoCart EV Manufacturing",
    category: "Golf Carts & Utility Vehicles",
    rating: 4.7,
    orders: "890+",
    moq: "$12,000",
    certifications: ["CE", "ISO 9001", "RoHS"],
    topProduct: "6-Seat Luxury Golf Cart with LED & Roof",
    unitPrice: "$2,200",
    containers: "20ft / 40ft / 40ft HC",
    samplePrice: "$350",
    leadTime: "28-40 days",
    verified: true,
    responseTime: "< 3 hours",
    image: "https://readdy.ai/api/search-image?query=luxury%206%20seat%20electric%20golf%20cart%20LED%20lights%20colorful%20roof%20canopy%20resort%20hotel%20pathway%20beautiful%20clean%20product%20photography&width=400&height=300&seq=gfm-golf2&orientation=landscape",
    avatar: "https://readdy.ai/api/search-image?query=chinese%20electric%20vehicle%20golf%20cart%20company%20logo%20professional%20clean%20minimal%20circle%20icon%20green%20technology&width=60&height=60&seq=gfmav-g2&orientation=squarish",
    mockProduct: { id: "wp-g2", title: "6-Seat Luxury Golf Cart with LED & Roof", unitPrice: 2200, moqUnits: 6, moqUSD: 13200, containerQty: { "20ft": 3, "40ft": 7 }, image: "https://readdy.ai/api/search-image?query=luxury%206%20seat%20electric%20golf%20cart%20LED%20lights%20colorful%20roof%20canopy%20resort%20hotel%20pathway%20beautiful%20clean%20product%20photography&width=400&height=400&seq=gfm-golf2p&orientation=squarish", category: "Vehicles", customizable: true },
    mockFactory: { name: "SinoCart EV Manufacturing", flag: "🇨🇳", minOrderUSD: 12000, containerTypes: ["20ft", "40ft", "40ft HC"], bulkLeadTime: "28-40 days", samplePrice: 350, sampleLeadTime: "10-14 days" },
  },
];

const regionStats = [
  { flag: "🇺🇸", region: "USA", factories: "180+", categories: "Electronics, Fashion, Sports" },
  { flag: "🇨🇳", region: "China", factories: "420+", categories: "Electronics, Packaging, Toys" },
  { flag: "🌍", region: "Europe", factories: "210+", categories: "Furniture, Fashion, Cosmetics" },
  { flag: "🌏", region: "Asia", factories: "380+", categories: "Beauty, Food, Textiles" },
  { flag: "🇨🇦", region: "Canada", factories: "90+", categories: "Eco Packaging, Outdoor, Food" },
  { flag: "🇦🇺", region: "Australia", factories: "60+", categories: "Health, Sports, Food" },
];

type ModalType = "sample" | "bulk" | "message" | "upload" | null;

interface ActiveModal {
  type: ModalType;
  factoryIdx: number;
}

export default function GlobalFactoryMarketplace() {
  const [activeRegion, setActiveRegion] = useState("all");
  const [modal, setModal] = useState<ActiveModal>({ type: null, factoryIdx: 0 });

  const filtered = activeRegion === "all"
    ? featuredFactories
    : featuredFactories.filter((f) => {
        if (activeRegion === "usa") return f.country === "USA";
        if (activeRegion === "europe") return ["Germany", "Italy", "France", "Turkey"].includes(f.country);
        if (activeRegion === "asia") return ["China", "South Korea", "Japan", "Vietnam", "India"].includes(f.country);
        if (activeRegion === "canada") return f.country === "Canada";
        if (activeRegion === "wine") return f.category.toLowerCase().includes("wine");
        if (activeRegion === "makeup") return f.category.toLowerCase().includes("makeup") || f.category.toLowerCase().includes("beauty") || f.category.toLowerCase().includes("cosmetic");
        if (activeRegion === "handbag") return f.category.toLowerCase().includes("handbag") || f.category.toLowerCase().includes("leather goods");
        return true;
      });

  const activeFactory = featuredFactories[modal.factoryIdx];

  const closeModal = () => setModal({ type: null, factoryIdx: 0 });

  return (
    <section className="py-16 px-4 md:px-8 bg-white">
      {/* Modals */}
      {modal.type === "upload" && <FactoryProductUploadModal onClose={closeModal} />}
      {modal.type === "message" && activeFactory && (
        <FactoryMessagingModal
          factory={{ name: activeFactory.name, flag: activeFactory.flag, city: activeFactory.city, avatar: activeFactory.avatar, verified: activeFactory.verified, responseTime: activeFactory.responseTime }}
          onClose={closeModal}
        />
      )}
      {modal.type === "sample" && activeFactory && (
        <SampleOrderModal
          factory={activeFactory.mockFactory}
          product={activeFactory.mockProduct}
          onClose={closeModal}
        />
      )}
      {modal.type === "bulk" && activeFactory && (
        <BulkOrderModal
          factory={activeFactory.mockFactory}
          product={activeFactory.mockProduct}
          onClose={closeModal}
        />
      )}

      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8 md:mb-12">
          <div className="flex items-center justify-center gap-2 mb-4 md:mb-5">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-gray-900 text-white text-xs font-bold rounded-full uppercase tracking-wide">
              <i className="ri-global-line" /> Global Factory Marketplace
            </span>
          </div>

          <h2 className="text-2xl sm:text-3xl md:text-5xl font-extrabold text-gray-900 mb-4 leading-tight">
            Buy Direct from the<br />
            <span style={{ color: "#B8860B" }}>World's Best Factories</span>
          </h2>

          {/* Big bold promise statement */}
          <div
            className="rounded-2xl px-5 sm:px-8 py-6 md:py-7 mb-8 max-w-4xl mx-auto relative overflow-hidden"
            style={{ background: "linear-gradient(135deg, #3D2000 0%, #7B4A00 40%, #B8860B 80%, #DAA520 100%)" }}
          >
            <div className="absolute inset-0 opacity-10" style={{ backgroundImage: "repeating-linear-gradient(45deg, transparent, transparent 20px, rgba(255,215,0,0.2) 20px, rgba(255,215,0,0.2) 40px)" }} />
            <div className="relative z-10">
              <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-extrabold text-white leading-tight mb-4 md:mb-6 text-center" style={{ fontFamily: "'Times New Roman', Times, serif" }}>
                Welcome to Place Bulk Orders from Our<br />
                <span style={{ color: "#FFD700" }}>Verified 1 Million+ Global Factories</span>
              </p>
              <p className="text-sm sm:text-base md:text-lg lg:text-xl font-bold leading-relaxed mb-4 md:mb-6 text-center" style={{ color: "rgba(255,255,255,0.95)", fontFamily: "'Times New Roman', Times, serif" }}>
                We work together to guarantee <span style={{ color: "#FFD700" }}>high quality products</span>, the most <span style={{ color: "#FFD700" }}>competitive prices</span> in the market, complete <span style={{ color: "#FFD700" }}>buyer fund safety</span>, and ensure every buyer receives exactly what they ordered — <span style={{ color: "#FFD700" }}>on time, every time.</span>
              </p>
              {/* 4 promise blocks */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3">
                {[
                  { icon: "ri-building-2-line", title: "1M+ Verified Factories", sub: "Audited & certified globally" },
                  { icon: "ri-medal-line", title: "High Quality Guaranteed", sub: "Inspection before shipment" },
                  { icon: "ri-price-tag-3-line", title: "Best Competitive Price", sub: "Factory-direct, no middlemen" },
                  { icon: "ri-safe-line", title: "Buyer Fund Safety", sub: "Escrow & full protection" },
                ].map((p) => (
                  <div
                    key={p.title}
                    className="rounded-xl p-3 md:p-4 text-center border"
                    style={{ background: "rgba(255,255,255,0.12)", borderColor: "rgba(255,215,0,0.3)" }}
                  >
                    <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full mx-auto mb-2" style={{ background: "rgba(255,215,0,0.2)" }}>
                      <i className={`${p.icon} text-base md:text-lg`} style={{ color: "#FFD700" }} />
                    </div>
                    <p className="text-xs md:text-sm font-extrabold text-white leading-tight mb-1">{p.title}</p>
                    <p className="text-xs hidden sm:block" style={{ color: "rgba(255,255,255,0.65)" }}>{p.sub}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Key Features Strip */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-8 md:mb-10">
          {[
            { icon: "ri-flask-line", title: "Sample First", desc: "Test product quality before committing to bulk", color: "bg-green-50 text-green-600" },
            { icon: "ri-ship-line", title: "Container Orders", desc: "20ft, 40ft, 40ft HC — full container loads", color: "bg-orange-50 text-orange-500" },
            { icon: "ri-message-3-line", title: "Direct Messaging", desc: "Chat with factory sellers in real time", color: "bg-amber-50 text-amber-600" },
            { icon: "ri-upload-cloud-line", title: "Factory Upload", desc: "Factories list products with bulk pricing", color: "bg-gray-50 text-gray-600" },
          ].map((f) => (
            <div key={f.title} className="flex items-start gap-2 md:gap-3 p-3 md:p-4 rounded-xl border border-gray-100">
              <div className={`w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg flex-shrink-0 ${f.color}`}>
                <i className={`${f.icon} text-sm md:text-base`} />
              </div>
              <div>
                <p className="text-xs md:text-sm font-bold text-gray-900">{f.title}</p>
                <p className="text-xs text-gray-400 mt-0.5 leading-relaxed hidden sm:block">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Region Filter */}
        <div className="flex gap-2 mb-6 md:mb-8 overflow-x-auto pb-2 justify-start md:justify-center">
          {[
            { id: "all", label: "🌐 All Regions" },
            { id: "usa", label: "🇺🇸 USA" },
            { id: "canada", label: "🇨🇦 Canada" },
            { id: "europe", label: "🌍 Europe" },
            { id: "asia", label: "🌏 Asia" },
            { id: "wine", label: "🍷 Wine" },
            { id: "makeup", label: "💄 Makeup" },
            { id: "handbag", label: "👜 Handbags" },
          ].map((r) => (
            <button
              key={r.id}
              onClick={() => setActiveRegion(r.id)}
              className={`px-3 md:px-4 py-2 rounded-full text-xs md:text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap flex-shrink-0 ${activeRegion === r.id ? "bg-gray-900 text-white" : "bg-gray-50 border border-gray-200 text-gray-600 hover:border-gray-400"}`}
            >
              {r.label}
            </button>
          ))}
        </div>

        {/* Factory Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 md:gap-6 mb-8 md:mb-10">
          {filtered.map((factory, fi) => (
            <div key={factory.id} className="bg-white rounded-2xl border border-gray-100 hover:border-orange-200 transition-all overflow-hidden group">
              {/* Product Image */}
              <div className="relative h-44 overflow-hidden">
                <img
                  src={factory.image}
                  alt={factory.topProduct}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                <div className="absolute top-3 right-3 bg-orange-500 text-white text-xs font-bold px-2.5 py-1 rounded-full">
                  MOQ {factory.moq}+
                </div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <img src={factory.avatar} alt={factory.name} className="w-9 h-9 rounded-lg border-2 border-white object-cover flex-shrink-0" />
                  <div>
                    <p className="text-white text-xs font-bold leading-tight">{factory.name}</p>
                    <p className="text-white/70 text-xs">{factory.flag} {factory.city}</p>
                  </div>
                </div>
              </div>

              <div className="p-5">
                {/* Category & Rating */}
                <div className="flex items-center justify-between mb-3">
                  <span className="text-xs font-semibold text-orange-600 bg-orange-50 px-2.5 py-1 rounded-full">{factory.category}</span>
                  <div className="flex items-center gap-1 text-xs text-gray-500">
                    <i className="ri-star-fill text-yellow-400" />
                    <span className="font-bold text-gray-900">{factory.rating}</span>
                    <span>· {factory.orders} orders</span>
                  </div>
                </div>

                {/* Top Product */}
                <p className="text-sm font-bold text-gray-900 mb-3 leading-snug">{factory.topProduct}</p>

                {/* Certifications */}
                <div className="flex flex-wrap gap-1.5 mb-4">
                  {factory.certifications.map((c) => (
                    <span key={c} className="text-xs bg-green-50 text-green-700 border border-green-100 px-2 py-0.5 rounded-full font-medium">
                      <i className="ri-checkbox-circle-fill mr-0.5" />{c}
                    </span>
                  ))}
                  {factory.verified && (
                    <span className="text-xs bg-orange-50 text-orange-600 border border-orange-100 px-2 py-0.5 rounded-full font-medium">
                      <i className="ri-shield-check-fill mr-0.5" />Verified
                    </span>
                  )}
                </div>

                {/* Pricing Grid */}
                <div className="grid grid-cols-3 gap-2 mb-4">
                  <div className="bg-gray-50 rounded-xl p-2.5 text-center">
                    <p className="text-xs text-gray-400">Unit Price</p>
                    <p className="text-sm font-extrabold text-gray-900">{factory.unitPrice}</p>
                  </div>
                  <div className="bg-green-50 rounded-xl p-2.5 text-center">
                    <p className="text-xs text-gray-400">Sample</p>
                    <p className="text-sm font-extrabold text-green-600">{factory.samplePrice}</p>
                  </div>
                  <div className="bg-orange-50 rounded-xl p-2.5 text-center">
                    <p className="text-xs text-gray-400">Lead Time</p>
                    <p className="text-xs font-bold text-orange-600">{factory.leadTime}</p>
                  </div>
                </div>

                {/* Container Types */}
                <div className="flex items-center gap-2 mb-4 text-xs text-gray-500">
                  <i className="ri-ship-line text-orange-400" />
                  <span className="font-medium">Containers:</span>
                  <span>{factory.containers}</span>
                </div>

                {/* Action Buttons — 3 rows */}
                <div className="space-y-2">
                  {/* Row 1: Sample + Bulk */}
                  <div className="flex gap-2">
                    <button
                      onClick={() => setModal({ type: "sample", factoryIdx: fi })}
                      className="flex-1 py-2.5 border-2 border-green-500 text-green-600 text-xs font-bold rounded-xl hover:bg-green-50 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-1"
                    >
                      <i className="ri-flask-line" /> Order Sample
                    </button>
                    <button
                      onClick={() => setModal({ type: "bulk", factoryIdx: fi })}
                      className="flex-1 py-2.5 bg-orange-500 text-white text-xs font-bold rounded-xl hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-1"
                    >
                      <i className="ri-ship-line" /> Bulk Order
                    </button>
                  </div>
                  {/* Row 2: Message */}
                  <button
                    onClick={() => setModal({ type: "message", factoryIdx: fi })}
                    className="w-full py-2.5 border-2 border-amber-400 text-amber-700 text-xs font-bold rounded-xl hover:bg-amber-50 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-1"
                  >
                    <i className="ri-message-3-line" /> Message Seller · Responds {factory.responseTime}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* ===== FACTORIES BY REGION — GOLD BACKGROUND ===== */}
        <div className="rounded-2xl p-5 md:p-8 mb-8 relative overflow-hidden" style={{ background: "linear-gradient(135deg, #B8860B 0%, #DAA520 25%, #FFD700 50%, #DAA520 75%, #B8860B 100%)" }}>
          {/* Decorative shimmer overlay */}
          <div className="absolute inset-0 opacity-20" style={{ backgroundImage: "repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(255,255,255,0.15) 10px, rgba(255,255,255,0.15) 20px)" }} />

          <div className="relative z-10">
            <div className="text-center mb-6">
              <h3 className="text-2xl font-extrabold mb-1" style={{ color: "#3D2000" }}>Factories by Region</h3>
              <p className="text-sm font-medium" style={{ color: "#5C3D00" }}>Verified manufacturers ready to ship containers worldwide</p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4 mb-6 md:mb-8">
              {regionStats.map((r) => (
                <div key={r.region} className="text-center rounded-xl p-4 border cursor-pointer hover:scale-105 transition-transform" style={{ background: "rgba(255,255,255,0.25)", borderColor: "rgba(255,255,255,0.4)" }}>
                  <div className="text-3xl mb-2">{r.flag}</div>
                  <p className="font-bold text-sm" style={{ color: "#3D2000" }}>{r.region}</p>
                  <p className="font-extrabold text-lg" style={{ color: "#5C3D00" }}>{r.factories}</p>
                  <p className="text-xs mt-1 leading-relaxed" style={{ color: "#6B4500" }}>{r.categories}</p>
                </div>
              ))}
            </div>

            {/* Factory Upload CTA */}
            <div className="rounded-xl p-4 md:p-6 border flex flex-col md:flex-row items-center gap-4 md:gap-6" style={{ background: "rgba(255,255,255,0.3)", borderColor: "rgba(255,255,255,0.5)" }}>
              <div className="flex-1 text-center md:text-left">
                <div className="flex items-center gap-2 justify-center md:justify-start mb-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg" style={{ background: "rgba(61,32,0,0.2)" }}>
                    <i className="ri-upload-cloud-line text-base" style={{ color: "#3D2000" }} />
                  </div>
                  <span className="font-extrabold text-sm md:text-base" style={{ color: "#3D2000" }}>Are You a Factory Owner?</span>
                </div>
                <p className="text-xs md:text-sm leading-relaxed" style={{ color: "#5C3D00" }}>
                  Upload your products with bulk pricing, set MOQ, container options, and sample prices. Reach thousands of verified buyers worldwide — for free.
                </p>
                <div className="flex flex-wrap gap-2 md:gap-3 mt-3 justify-center md:justify-start">
                  {["Free to list", "Verified badge", "Global buyers", "Direct orders"].map((tag) => (
                    <span key={tag} className="text-xs font-semibold px-2 md:px-3 py-1 rounded-full" style={{ background: "rgba(61,32,0,0.15)", color: "#3D2000" }}>
                      <i className="ri-check-line mr-1" />{tag}
                    </span>
                  ))}
                </div>
              </div>
              <div className="flex flex-col gap-3 flex-shrink-0 w-full md:w-auto">
                <button
                  onClick={() => setModal({ type: "upload", factoryIdx: 0 })}
                  className="flex items-center justify-center gap-2 px-5 md:px-6 py-3 font-bold rounded-full cursor-pointer whitespace-nowrap transition-all hover:scale-105"
                  style={{ background: "#3D2000", color: "#FFD700" }}
                >
                  <i className="ri-building-2-line" /> Upload Your Products
                </button>
                <Link
                  to="/wholesale"
                  className="flex items-center justify-center gap-2 px-5 md:px-6 py-3 font-bold rounded-full cursor-pointer whitespace-nowrap border-2 transition-all hover:scale-105"
                  style={{ borderColor: "#3D2000", color: "#3D2000" }}
                >
                  <i className="ri-global-line" /> Browse All Factories
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* How It Works — 4 Steps */}
        <div className="bg-gray-50 rounded-2xl p-8 mb-8">
          <h3 className="text-xl font-extrabold text-gray-900 text-center mb-8">How Container Wholesale Works</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { step: "1", icon: "ri-search-line", title: "Browse Verified Factories", desc: "Filter by region, category, and certifications. All factories are verified with official documents.", color: "bg-orange-50 text-orange-500" },
              { step: "2", icon: "ri-message-3-line", title: "Message the Seller", desc: "Chat directly with the factory. Ask about MOQ, lead time, custom branding, and get a formal quote.", color: "bg-amber-50 text-amber-500" },
              { step: "3", icon: "ri-flask-line", title: "Order a Sample First", desc: "Request product samples to test quality. Sample cost is deducted from your first bulk order.", color: "bg-green-50 text-green-500" },
              { step: "4", icon: "ri-ship-line", title: "Place Container Order", desc: "Minimum $8,000 per order. Choose 20ft, 40ft, or 40ft HC container. Factory ships worldwide.", color: "bg-gray-100 text-gray-600" },
            ].map((s) => (
              <div key={s.step} className="text-center">
                <div className={`w-14 h-14 flex items-center justify-center rounded-2xl mx-auto mb-3 relative ${s.color}`}>
                  <i className={`${s.icon} text-2xl`} />
                  <span className="absolute -top-2 -right-2 w-6 h-6 flex items-center justify-center bg-orange-500 text-white text-xs font-bold rounded-full">{s.step}</span>
                </div>
                <h4 className="font-bold text-gray-900 text-sm mb-1">{s.title}</h4>
                <p className="text-xs text-gray-500 leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 md:gap-6 bg-gradient-to-r from-orange-500 to-amber-500 rounded-2xl p-5 md:p-7">
          <div className="text-center sm:text-left">
            <h3 className="text-lg md:text-xl font-extrabold text-white mb-1">Ready to Place a Container Order?</h3>
            <p className="text-white/80 text-xs md:text-sm">Browse 1,340+ verified factories from 40+ countries. Sample first, then bulk.</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0 w-full sm:w-auto">
            <Link
              to="/wholesale"
              className="flex items-center justify-center gap-2 px-5 md:px-6 py-3 bg-white text-orange-600 text-sm font-bold rounded-full hover:bg-orange-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-global-line" /> Browse All Factories
            </Link>
            <button
              onClick={() => setModal({ type: "upload", factoryIdx: 0 })}
              className="flex items-center justify-center gap-2 px-5 md:px-6 py-3 bg-white/20 border border-white/40 text-white text-sm font-bold rounded-full hover:bg-white/30 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-building-2-line" /> List Your Factory
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
